function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import { Skeleton, Button, Spin, Modal, Alert, Divider, Tabs, message, DatePicker, Form } from 'antd';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Eyedropper, BootstrapReboot, Clipboard2CheckFill, Search } from 'react-bootstrap-icons';
import LaboForm from "../components/forms/LaboForm";
import DisplayLabReport from "../components/DisplayLabReport";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TabPane = Tabs.TabPane;
var confirm = Modal.confirm;
var RangePicker = DatePicker.RangePicker;

var ProcessLaboratory = function ProcessLaboratory() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      queueCustomers = _useState2[0],
      setQueueCustomers = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      sampledCustomers = _useState4[0],
      setSampledCustomers = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      processModalVisible = _useState8[0],
      setProcessModalVisible = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isLaboReportsModalVisible = _useState10[0],
      setIsLaboReportsModalVisible = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      processModalSpinVisible = _useState12[0],
      setProcessModalSpinVisible = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      dataUpdated = _useState14[0],
      setDataUpdated = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      sampleid = _useState16[0],
      setSampleid = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      searchCustomers = _useState18[0],
      setSearchCustomers = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      selectedSearchCustomer = _useState20[0],
      setSelectedSearchCustomer = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isSampleProcessing = _useState22[0],
      setIsSampleProcessing = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      laboFormVisible = _useState24[0],
      setLaboFormVisible = _useState24[1];

  var _useState25 = useState(''),
      _useState26 = _slicedToArray(_useState25, 2),
      errorMessage = _useState26[0],
      setErrorMessage = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      selectedQueueCustomer = _useState28[0],
      setSelectedQueueCustomer = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      selectedSampledCustomer = _useState30[0],
      setSelectedSampledCustomer = _useState30[1];

  var _useState31 = useState(null),
      _useState32 = _slicedToArray(_useState31, 2),
      timeFrame = _useState32[0],
      setTimeFrame = _useState32[1];

  var onTimeTravel = function onTimeTravel(values) {
    setTimeFrame(values.range);
    setIsLaboReportsModalVisible(true);
  };

  var handleProcess = function handleProcess(customer) {
    setSelectedSampledCustomer(customer);
    setProcessModalSpinVisible(true);
    setProcessModalVisible(true);
    setLaboFormVisible(false);
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: Common.currentUser.id
    }).then(function (response) {
      setProcessModalSpinVisible(false);

      if (response.data.authenticated == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));

        if (response.data.user.role == 2 || response.data.user.role == 6 || response.data.user.role == 10) {
          //LABO USER  
          setLaboFormVisible(true);
        }

        if (response.data.user.role != 2 && response.data.user.role != 6 && response.data.user.role != 10) {
          setErrorMessage("Vous n'avez pas accès à cette fonctionnalité");
        }
      } else {
        console.log('user not connected');
        navigate('/');
      }
    })["catch"](function (error) {
      setProcessModalSpinVisible(false);
    });
  };

  var handleSample = function handleSample(customer) {
    setSelectedQueueCustomer(customer);
    setErrorMessage('');
    setIsDataLoading(true);
    return axios.post(Common.baseApiUrl + 'setcustomersampled', {
      cid: customer.id.toString(),
      userid: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setDataUpdated(true);
        setSelectedSampledCustomer(response.data.customer);
        message.success({
          content: "Echantillon " + response.data.customer.laboresult.sampleid + " crée !",
          duration: 5
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          duration: 3
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        duration: 3
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };

  var confirmSample = function confirmSample(customer) {
    axios.get(Common.baseApiUrl + 'getnextsampleid/' + Common.currentUser.zone_id).then(function (response) {
      if (response.data.status == 200) {
        setSampleid(response.data.sampleid);
        confirm({
          title: 'Confirmation',
          //content: 'Confirmez-vous le prelevement de '+customer.firstname+' '+customer.lastname+' | N.Echantillon : '+response.data.sampleid,
          content: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["Confirmez-vous le prelevement de ", /*#__PURE__*/_jsx("b", {
                children: customer.firstname + ' ' + customer.lastname
              }), " ? "]
            }), /*#__PURE__*/_jsx("h1", {
              children: 'N.Echantillon : ' + response.data.sampleid
            })]
          }),
          cancelText: 'Annuler',
          width: 720,
          okText: 'Confirmer',
          onOk: function onOk() {
            handleSample(customer);
          }
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          duration: 3
        });
      }
    })["catch"](function (error) {})["finally"](function () {});
  };

  var onFinishSearch = function onFinishSearch(values) {};

  useEffect(function () {
    setDataUpdated(false);
    setQueueCustomers([]);
    setSampledCustomers([]);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdayqueue/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getcurrentdaysampled/' + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(false);

      if (response[0].data.status == 200) {
        setQueueCustomers(response[0].data.customers);
      }

      if (response[1].data.status == 200) {
        setSampledCustomers(response[1].data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [dataUpdated]);
  useEffect(function () {
    setInterval(function () {
      setDataUpdated(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal, {
      title: "Rapport de Labo",
      visible: isLaboReportsModalVisible,
      onCancel: function onCancel() {
        setIsLaboReportsModalVisible(false);
      },
      destroyOnClose: true,
      width: "97%",
      footer: null,
      cancelText: "Annuler",
      children: /*#__PURE__*/_jsx(DisplayLabReport, {
        timeFrame: timeFrame
      })
    }), /*#__PURE__*/_jsxs(Modal, {
      title: "Proc\xE9dure de traitement candidat",
      visible: processModalVisible,
      onCancel: function onCancel() {
        setProcessModalVisible(false);
      },
      destroyOnClose: true,
      footer: null,
      cancelText: "Annuler",
      children: [selectedSampledCustomer != null && /*#__PURE__*/_jsxs("div", {
        style: {
          background: '#FCB917',
          padding: '10px',
          borderRadius: '0px 10px 10px 10px'
        },
        children: [/*#__PURE__*/_jsxs("h5", {
          children: ["RNC : ", selectedSampledCustomer.rnc]
        }), /*#__PURE__*/_jsxs("h3", {
          children: ["Echantillon Numero: ", selectedSampledCustomer.laboresult != null && selectedSampledCustomer.laboresult.sampleid]
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Pr\xE9nom : "
          }), selectedSampledCustomer.firstname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Nom : "
          }), selectedSampledCustomer.lastname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Tel : "
          }), selectedSampledCustomer.mobile, /*#__PURE__*/_jsx("br", {})]
        })]
      }), processModalSpinVisible && /*#__PURE__*/_jsx("div", {
        style: {
          margin: '0px auto',
          padding: '20px'
        },
        children: /*#__PURE__*/_jsx(Spin, {})
      }), errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage,
        showIcon: true
      }), laboFormVisible && /*#__PURE__*/_jsx(LaboForm, {
        handler: function handler() {
          setDataUpdated(true), setProcessModalVisible(false);
        },
        customer: selectedSampledCustomer
      })]
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsxs(Tabs, {
              animated: true,
              children: [/*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Eyedropper, {
                    size: 22
                  }), "PRELEVEMENT"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "white-bg cool-radius",
                    children: [/*#__PURE__*/_jsx("h5", {
                      children: "EN ATTENTE DE PRELEVEMENT"
                    }), /*#__PURE__*/_jsx(Divider, {}), queueCustomers && /*#__PURE__*/_jsxs(Table, {
                      bordered: true,
                      responsive: true,
                      children: [/*#__PURE__*/_jsx("thead", {
                        children: /*#__PURE__*/_jsxs("tr", {
                          children: [/*#__PURE__*/_jsx("th", {
                            children: "Date"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "RNC"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Pr\xE9nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "T\xE9l\xE9phone"
                          }), /*#__PURE__*/_jsx("th", {
                            children: /*#__PURE__*/_jsx(Eyedropper, {
                              size: 22
                            })
                          })]
                        })
                      }), /*#__PURE__*/_jsx("tbody", {
                        children: queueCustomers.map(function (c) {
                          return /*#__PURE__*/_jsxs("tr", {
                            children: [/*#__PURE__*/_jsx("td", {
                              children: new Date(c.created_at).toLocaleDateString('Fr', {
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.rnc
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.firstname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.lastname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.mobile
                            }), /*#__PURE__*/_jsx("td", {
                              children: /*#__PURE__*/_jsx(Button, {
                                type: "primary",
                                onClick: function onClick() {
                                  confirmSample(c);
                                },
                                children: "Prelever"
                              })
                            })]
                          }, c.id);
                        })
                      })]
                    }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })]
                  })
                })
              }, 1), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(BootstrapReboot, {
                    size: 22
                  }), " ATTENTE RESULTATS"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "white-bg cool-radius",
                    children: [/*#__PURE__*/_jsx("h5", {
                      children: "EN ATTENTE DE RESULTATS"
                    }), /*#__PURE__*/_jsx(Divider, {}), sampledCustomers && /*#__PURE__*/_jsxs(Table, {
                      bordered: true,
                      responsive: true,
                      children: [/*#__PURE__*/_jsx("thead", {
                        children: /*#__PURE__*/_jsxs("tr", {
                          children: [/*#__PURE__*/_jsx("th", {
                            children: "N.Echant."
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Date"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "RNC"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Pr\xE9nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "T\xE9l\xE9phone"
                          }), /*#__PURE__*/_jsxs("th", {
                            children: [/*#__PURE__*/_jsx(Eyedropper, {
                              size: 22
                            }), " ", /*#__PURE__*/_jsx("b", {
                              children: "G"
                            })]
                          }), /*#__PURE__*/_jsxs("th", {
                            children: [/*#__PURE__*/_jsx(Eyedropper, {
                              size: 22
                            }), " ", /*#__PURE__*/_jsx("b", {
                              children: "R"
                            })]
                          }), /*#__PURE__*/_jsx("th", {})]
                        })
                      }), /*#__PURE__*/_jsx("tbody", {
                        children: sampledCustomers.filter(function (cus) {
                          return cus.laboresult.group == null || cus.laboresult.rhesus == null;
                        }).map(function (c) {
                          return /*#__PURE__*/_jsxs("tr", {
                            children: [/*#__PURE__*/_jsx("td", {
                              children: c.laboresult.sampleid
                            }), /*#__PURE__*/_jsx("td", {
                              children: new Date(c.created_at).toLocaleDateString('Fr', {
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.rnc
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.firstname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.lastname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.mobile
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.laboresult.group != null && c.laboresult.group
                            }), /*#__PURE__*/_jsxs("td", {
                              children: [c.laboresult.rhesus != null && c.laboresult.rhesus == '+' && /*#__PURE__*/_jsx("b", {
                                children: "Positif"
                              }), c.laboresult.rhesus != null && c.laboresult.rhesus == '-' && /*#__PURE__*/_jsx("b", {
                                children: "N\xE9gatif"
                              })]
                            }), /*#__PURE__*/_jsx("td", {
                              children: /*#__PURE__*/_jsx(Button, {
                                type: "primary",
                                onClick: function onClick() {
                                  handleProcess(c);
                                },
                                children: "Saisir"
                              })
                            })]
                          }, 'q' + c.id.toString());
                        })
                      })]
                    }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })]
                  })
                })
              }, 2), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Clipboard2CheckFill, {
                    size: 22
                  }), " RESULTATS"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "white-bg cool-radius",
                    children: [/*#__PURE__*/_jsx("h5", {
                      children: "RESULTATS GROUPAGE"
                    }), /*#__PURE__*/_jsx(Divider, {}), sampledCustomers && /*#__PURE__*/_jsxs(Table, {
                      bordered: true,
                      responsive: true,
                      children: [/*#__PURE__*/_jsx("thead", {
                        children: /*#__PURE__*/_jsxs("tr", {
                          children: [/*#__PURE__*/_jsx("th", {
                            children: "N.Echant."
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Date"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "RNC"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Pr\xE9nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "Nom"
                          }), /*#__PURE__*/_jsx("th", {
                            children: "T\xE9l\xE9phone"
                          }), /*#__PURE__*/_jsxs("th", {
                            children: [/*#__PURE__*/_jsx(Eyedropper, {
                              size: 22
                            }), " ", /*#__PURE__*/_jsx("b", {
                              children: "G"
                            })]
                          }), /*#__PURE__*/_jsxs("th", {
                            children: [/*#__PURE__*/_jsx(Eyedropper, {
                              size: 22
                            }), " ", /*#__PURE__*/_jsx("b", {
                              children: "R"
                            })]
                          }), /*#__PURE__*/_jsx("th", {})]
                        })
                      }), /*#__PURE__*/_jsx("tbody", {
                        children: sampledCustomers.filter(function (cus) {
                          return cus.laboresult.group != null || cus.laboresult.rhesus != null;
                        }).map(function (c) {
                          return /*#__PURE__*/_jsxs("tr", {
                            children: [/*#__PURE__*/_jsx("td", {
                              children: c.laboresult.sampleid
                            }), /*#__PURE__*/_jsx("td", {
                              children: new Date(c.created_at).toLocaleDateString('Fr', {
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.rnc
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.firstname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.lastname
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.mobile
                            }), /*#__PURE__*/_jsx("td", {
                              children: c.laboresult.group != null && c.laboresult.group
                            }), /*#__PURE__*/_jsxs("td", {
                              children: [c.laboresult.rhesus != null && c.laboresult.rhesus == '+' && /*#__PURE__*/_jsx("b", {
                                children: "Positif"
                              }), c.laboresult.rhesus != null && c.laboresult.rhesus == '-' && /*#__PURE__*/_jsx("b", {
                                children: "N\xE9gatif"
                              })]
                            }), /*#__PURE__*/_jsx("td", {
                              children: /*#__PURE__*/_jsx(Button, {
                                type: "primary",
                                onClick: function onClick() {
                                  handleProcess(c);
                                },
                                children: "Saisir"
                              })
                            })]
                          }, 'q' + c.id.toString());
                        })
                      })]
                    }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })]
                  })
                })
              }, 3), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Search, {
                    size: 22
                  }), " RECHERCHE"]
                })
              }, 4)]
            })
          })
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 3,
          md: 3,
          children: [/*#__PURE__*/_jsxs(Form, {
            onFinish: onTimeTravel,
            layout: "vertical",
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "range",
              rules: [{
                required: true,
                message: 'Veuillez choisir une periode'
              }],
              children: /*#__PURE__*/_jsx(RangePicker, {
                showTime: {
                  format: 'HH:mm'
                }
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                htmlType: "submit",
                type: "primary",
                children: "Chercher"
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            className: "cool-radius",
            style: {
              textAlign: 'center',
              background: '#FFDE08'
            },
            children: [/*#__PURE__*/_jsx("h2", {
              children: queueCustomers.length.toLocaleString()
            }), /*#__PURE__*/_jsx("span", {
              children: "En attente de pr\xE9l\xE8vement"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h2", {
              children: sampledCustomers.filter(function (c) {
                return c.laboresult.group == null || c.laboresult.rhesus == null;
              }).length.toLocaleString()
            }), /*#__PURE__*/_jsx("span", {
              children: "En attente de r\xE9sultats"
            })]
          }), /*#__PURE__*/_jsx("br", {})]
        })]
      })
    })]
  });
};

export default ProcessLaboratory;